import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "overflow-x-auto rounded-lg border border-gray-200 bg-white shadow-sm" }
const _hoisted_3 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_4 = {
  key: 0,
  class: "bg-gray-50 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500"
}
const _hoisted_5 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_6 = { class: "hover:bg-gray-50 transition-colors duration-150 relative" }
const _hoisted_7 = {
  key: 0,
  colspan: "8",
  class: "absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10"
}
const _hoisted_8 = { class: "whitespace-nowrap px-6 py-4" }
const _hoisted_9 = { class: "font-medium text-gray-900" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2 space-y-1"
}
const _hoisted_11 = { class: "flex flex-wrap gap-1 items-center" }
const _hoisted_12 = {
  key: 0,
  class: "px-2 py-0.5 text-xs rounded-full opacity-75 bg-gray-400 text-gray-700"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "flex flex-wrap gap-1" }
const _hoisted_15 = { class: "whitespace-nowrap px-6 py-4 text-sm" }
const _hoisted_16 = {
  key: 1,
  class: "whitespace-nowrap px-6 py-4 text-sm"
}
const _hoisted_17 = { class: "font-medium text-gray-900" }
const _hoisted_18 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_19 = { class: "px-6 py-4 text-sm text-gray-900" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "font-medium" }
const _hoisted_22 = { class: "text-xs text-gray-500 space-x-2" }
const _hoisted_23 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_24 = { class: "px-6 py-4 text-sm text-gray-900" }
const _hoisted_25 = { class: "flex items-center space-x-2" }
const _hoisted_26 = { class: "flex flex-col" }
const _hoisted_27 = { class: "font-medium" }
const _hoisted_28 = {
  key: 0,
  class: "text-xs text-blue-600"
}
const _hoisted_29 = {
  key: 1,
  class: "text-xs text-green-600"
}
const _hoisted_30 = {
  key: 0,
  class: "text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full"
}
const _hoisted_31 = { class: "whitespace-nowrap px-6 py-4 text-sm" }
const _hoisted_32 = {
  key: 0,
  class: "relative dropdown-container"
}
const _hoisted_33 = ["onClick", "disabled"]
const _hoisted_34 = { class: "flex items-center flex-1" }
const _hoisted_35 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_36 = {
  key: 0,
  class: "absolute z-10 mt-2 w-full min-w-[200px] bg-white rounded-lg shadow-lg border border-gray-200"
}
const _hoisted_37 = { class: "py-2 max-h-48 overflow-y-auto" }
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-500"
}
const _hoisted_40 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_41 = { class: "px-6 py-4 text-sm" }
const _hoisted_42 = { class: "px-6 py-4 text-sm" }
const _hoisted_43 = { class: "flex items-center space-x-2" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 3,
  class: "text-green-600 font-medium"
}
const _hoisted_48 = {
  key: 0,
  class: "bg-gray-50"
}
const _hoisted_49 = ["colspan"]
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "flex items-center gap-2" }
const _hoisted_52 = { class: "mt-2 p-4 bg-red-50 border border-red-200 rounded-lg transition-all duration-300 ease-in-out" }
const _hoisted_53 = { class: "text-sm text-red-700 leading-relaxed whitespace-pre-wrap" }

import { ref, onMounted, onUnmounted, watch } from 'vue';
import { useVaccinationConfigurations } from "@/composables/tasks/vaccination/useVaccinationConfigurations";
import { useVaccination } from "@/composables/tasks/vaccination/useVaccination";
import { useTaskHistory } from "@/composables/tasks/useTaskHistory";
import { useNotifications } from "@/composables/useNotifications";
import { getVaccinationConfigurationInstructions, VaccineConfiguration } from "@/types/v2/task/vaccination/configuration.types";
import { VaccineMethod, Tank, GroupTag } from "@/types/v2";
import { getVaccinationProductDisplayItems } from "@/utils/v2/tasks/display";

import JustificationModal from "@/components/v2/Modal/JustificationModal.vue";
import WeightIcon from "@/components/v2/UI/Icons/WeightIcon.vue";

interface Props {
    configurations: VaccineConfiguration[],
    vaccineMethods?: VaccineMethod[],
    tanks: Tank[]
}

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'BathVaccinationConfigurationsTable',
  props: {
    configurations: {},
    vaccineMethods: {},
    tanks: {}
  },
  emits: ["openWeightModal"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
// eslint-disable-next-line no-undef
const emit = __emit;

const {
    startBathProcess,
    finishBathProcess,
    getBathProcessStatus,
    getConfigurationTitle,
    getConfigurationTags,
    updateConfiguration
} = useVaccinationConfigurations();

const { availableTags } = useVaccination();
const { recordChange } = useTaskHistory();
const { showSuccess, showError } = useNotifications();

// Local state for tracking timers
const activeTimers = ref<Record<string, number>>({});

// Local state for tag selection
const selectedTags = ref<Record<number, GroupTag | null>>({});
const isUpdating = ref<Record<number, boolean>>({});
const dropdownOpen = ref<Record<number, boolean>>({});

// Local state for instructions visibility
const showInstructions = ref<Record<number, boolean>>({});

// Initialize instructions as expanded by default
watch(() => props.configurations, (configs) => {
    if (configs) {
        configs.forEach((config, index) => {
            if (getVaccinationConfigurationInstructions(config) && showInstructions.value[index] === undefined) {
                showInstructions.value[index] = true;
            }
        });
    }
}, { immediate: true });

// Toggle instructions visibility
const toggleInstructions = (configIndex: number) => {
    showInstructions.value[configIndex] = !showInstructions.value[configIndex];
};

// Helper to find the new tag (tag in destinationGroup but not in sourceGroup) - for standard bath
const findNewTag = (config: VaccineConfiguration): GroupTag | null => {
    const bathConfig = config as any;
    if (!isStandardBath(config)) return null;
    
    const sourceTags = bathConfig.sourceGroup?.tags || [];
    const destinationTags = bathConfig.destinationGroup?.tags || [];
    
    // Find tags in destination that are not in source (excluding Start Tag)
    const sourceTagTitles = new Set(
        sourceTags
            .filter((tag: GroupTag) => tag.title !== 'Start Tag')
            .map((tag: GroupTag) => tag.title)
    );
    
    const newTag = destinationTags.find((tag: GroupTag) => 
        tag.title !== 'Start Tag' && !sourceTagTitles.has(tag.title)
    );
    
    return newTag || null;
};

// Get bath type label
const getBathTypeLabel = (config: VaccineConfiguration): string => {
    const bathConfig = config as any;
    if (bathConfig.isSimplifiedBath) return 'Simplified Bath';
    if (bathConfig.isStandardBath) return 'Standard Bath';
    return 'Bath';
};

// Check if it's simplified bath
const isSimplifiedBath = (config: VaccineConfiguration): boolean => {
    const bathConfig = config as any;
    return bathConfig.isSimplifiedBath === true && !!bathConfig.tank;
};

// Check if it's standard bath
const isStandardBath = (config: VaccineConfiguration): boolean => {
    const bathConfig = config as any;
    return bathConfig.isStandardBath === true && !!(bathConfig.sourceTank && bathConfig.destinationTank);
};

// Get vaccines display (equivalent to challenge materials)
const getVaccinesDisplay = (config: VaccineConfiguration) => {
    return getVaccinationProductDisplayItems(config, 'Bath');
};

// Format duration for display
const formatDuration = (minutes: number): string => {
    return `${minutes} min`;
};

// Get process status for display
const getProcessStatus = (config: VaccineConfiguration) => {
    const status = getBathProcessStatus(config.key);
    if (!status) {
        return { status: 'not_started', label: 'Ready to Start', color: 'gray' };
    }

    switch (status.status) {
        case 'not_started':
            return { status: 'not_started', label: 'Ready to Start', color: 'gray' };
        case 'in_progress':
            return { status: 'in_progress', label: 'In Progress', color: 'blue' };
        case 'completed':
            return { status: 'completed', label: 'Completed', color: 'green' };
        default:
            return { status: 'unknown', label: 'Unknown', color: 'gray' };
    }
};

// Calculate elapsed time for running processes (reactive)
const currentTime = ref(Date.now());
const getElapsedTime = (startedAt: string): string => {
    const startTime = new Date(startedAt).getTime();
    const elapsedMs = currentTime.value - startTime;
    const totalSeconds = Math.floor(elapsedMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}m ${seconds}s`;
};

// Calculate actual duration between start and completion
const getActualDuration = (startedAt: string, completedAt: string): string => {
    const startTime = new Date(startedAt).getTime();
    const endTime = new Date(completedAt).getTime();
    const durationMs = endTime - startTime;
    const totalSeconds = Math.floor(durationMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}m ${seconds}s`;
};

// Update current time every second for elapsed time display
let timeInterval: number;
onMounted(() => {
    timeInterval = setInterval(() => {
        currentTime.value = Date.now();
    }, 1000); // Update every second
    
    document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
    if (timeInterval) {
        clearInterval(timeInterval);
    }
    document.removeEventListener('click', handleClickOutside);
});

// Handle starting bath process
const handleStartProcess = async (configIndex: number) => {
    const config = props.configurations[configIndex];
    if (!config) return;

    await startBathProcess(configIndex);
};

// Handle finishing bath process
const handleFinishProcess = async (configIndex: number) => {
    const config = props.configurations[configIndex];
    if (!config) return;

    await finishBathProcess(configIndex);
};

// Handle weight recording
const handleRecordWeight = (config: VaccineConfiguration) => {
    emit('openWeightModal', config);
};

// Check if weight recording should be shown for this configuration
const shouldShowWeightButton = (config: VaccineConfiguration): boolean => {
    const bathConfig = config as any;
    // Show for both simplified and standard baths if they have targetWeightAmount
    return !!(bathConfig.targetWeightAmount);
};

// Tag dropdown handlers
const toggleDropdown = (configIndex: number) => {
    dropdownOpen.value[configIndex] = !dropdownOpen.value[configIndex];
};

const closeDropdown = (configIndex: number) => {
    dropdownOpen.value[configIndex] = false;
};

const closeAllDropdowns = () => {
    Object.keys(dropdownOpen.value).forEach(key => {
        dropdownOpen.value[parseInt(key)] = false;
    });
};

// Handle clicks outside dropdown
const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown-container')) {
        closeAllDropdowns();
    }
};

// Handle tag selection from custom dropdown
const selectTag = async (configIndex: number, tag: GroupTag) => {
    const oldTag = selectedTags.value[configIndex];
    const config = props.configurations[configIndex];
    const bathConfig = config as any;
    
    // Only handle standard bath configurations
    if (!isStandardBath(config)) return;
    
    // Set loading state
    isUpdating.value[configIndex] = true;

    try {
        const success = await recordChange({
            fieldPath: `configurations[${configIndex}].selectedTag`,
            fieldName: `Tag (${tag.title})`,
            oldValue: {
              config: config.key,
              key: oldTag?.key || 'None',
              value: oldTag?.title || 'None',
            },
            newValue: {
              config: config.key,
              key: tag.key,
              value: tag.title,
            },
            context: 'VaccinationConfiguration',
            contextType: 'edit',
            workflowStage: 'setup',
            requireJustification: true,
            justification: ''
        });

        if (success) {
            // Update the selected tag
            selectedTags.value[configIndex] = tag;
            
            // Update destination group to include the new tag
            // First, get source tags to preserve them
            const sourceTags = bathConfig.sourceGroup?.tags || [];
            const sourceTagTitles = new Set(
                sourceTags
                    .filter((t: GroupTag) => t.title !== 'Start Tag')
                    .map((t: GroupTag) => t.title)
            );
            
            // Create updated destination group with source tags + new tag
            const updatedDestGroup = bathConfig.destinationGroup
                ? { ...bathConfig.destinationGroup }
                : { key: '', name: '', tags: [] } as any;
            
            if (!updatedDestGroup.tags) {
                updatedDestGroup.tags = [];
            } else {
                updatedDestGroup.tags = [...updatedDestGroup.tags];
            }
            
            // Remove old new tag (tag that was in destination but not in source)
            updatedDestGroup.tags = updatedDestGroup.tags.filter((t: GroupTag) => 
                sourceTagTitles.has(t.title) || t.title === tag.title
            );
            
            // Add new tag if it doesn't exist
            const tagExists = updatedDestGroup.tags.some((t: GroupTag) => t.title === tag.title);
            if (!tagExists) {
                updatedDestGroup.tags.push(tag);
            }
            
            // Update the destination group
            await updateConfiguration(configIndex, -1, 'destinationGroup', updatedDestGroup);
            
            // Show success notification
            showSuccess(
                "Tag Updated", 
                `Tag has been changed to "${tag.title}".`
            );
        }
    } catch (error) {
        console.error('Error updating tag:', error);
        showError(
            "Tag Update Failed", 
            "Failed to update tag. Please try again."
        );
    } finally {
        // Clear loading state
        isUpdating.value[configIndex] = false;
    }
    
    closeDropdown(configIndex);
};

// Watch for configuration changes to initialize selected tags
watch(() => props.configurations, (configs) => {
    if (configs) {
        configs.forEach((config, index) => {
            // Initialize selected tag from destination group (new tag) for standard bath
            if (isStandardBath(config) && !selectedTags.value[index]) {
                const newTag = findNewTag(config);
                if (newTag) {
                    selectedTags.value[index] = newTag;
                }
            }
        });
    }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[0] || (_cache[0] = _createElementVNode("th", { class: "bg-gray-50 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500" }, "Configuration", -1)),
            _cache[1] || (_cache[1] = _createElementVNode("th", { class: "bg-gray-50 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500" }, "Bath Type", -1)),
            (_ctx.configurations.some(config => !isSimplifiedBath(config)))
              ? (_openBlock(), _createElementBlock("th", _hoisted_4, "Amount"))
              : _createCommentVNode("", true),
            _cache[2] || (_cache[2] = _createElementVNode("th", { class: "bg-gray-50 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500" }, "IVP", -1)),
            _cache[3] || (_cache[3] = _createElementVNode("th", { class: "bg-gray-50 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500" }, "Duration", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("th", { class: "bg-gray-50 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500" }, "Tag", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("th", { class: "bg-gray-50 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500" }, "Status", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("th", { class: "bg-gray-50 px-6 py-3 text-left text-xs font-medium tracking-wider text-gray-500" }, "Actions", -1))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configurations, (config, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: config.key
            }, [
              _createElementVNode("tr", _hoisted_6, [
                (isUpdating.value[index])
                  ? (_openBlock(), _createElementBlock("td", _hoisted_7, _cache[7] || (_cache[7] = [
                      _createStaticVNode("<div class=\"flex items-center space-x-2\"><svg class=\"animate-spin h-5 w-5 text-blue-600\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg><span class=\"text-sm text-gray-600\">Updating...</span></div>", 1)
                    ])))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(getConfigurationTitle)(config)), 1),
                  (isStandardBath(config))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-xs text-gray-500 mb-1" }, "From:", -1)),
                          _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((config as any).sourceGroup?.tags?.filter((tag) => tag.title !== 'Start Tag') || [], (tag) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: `source-${tag.key}`,
                                class: "px-2 py-0.5 text-xs rounded-full opacity-75",
                                style: _normalizeStyle({
                                            backgroundColor: tag.backgroundColor,
                                            color: tag.textColor
                                        })
                              }, _toDisplayString(tag.title), 5))
                            }), 128)),
                            (!(config as any).sourceGroup?.tags?.filter((tag) => tag.title !== 'Start Tag')?.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Unmarked "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_unref(getConfigurationTags)(config).length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-xs text-gray-500 mb-1" }, "To:", -1)),
                              _createElementVNode("div", _hoisted_14, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getConfigurationTags)(config), (tag) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: `dest-${tag.key}`,
                                    class: "px-2 py-0.5 text-xs rounded-full",
                                    style: _normalizeStyle({
                                            backgroundColor: tag.backgroundColor,
                                            color: tag.textColor
                                        })
                                  }, _toDisplayString(tag.title), 5))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium", {
                                'bg-blue-100 text-blue-800': isSimplifiedBath(config),
                                'bg-green-100 text-green-800': isStandardBath(config),
                                'bg-gray-100 text-gray-800': !isSimplifiedBath(config) && !isStandardBath(config)
                              }])
                  }, _toDisplayString(getBathTypeLabel(config)), 3)
                ]),
                (!isSimplifiedBath(config))
                  ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString((config as any).targetAmount || 0), 1),
                      ((config as any).targetWeightAmount)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
                            _createElementVNode("strong", null, _toDisplayString((config as any).targetWeightAmount), 1),
                            _cache[11] || (_cache[11] = _createTextVNode(" weight records required "))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("td", _hoisted_19, [
                  (getVaccinesDisplay(config).length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getVaccinesDisplay(config), (vaccine, vIdx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: vIdx,
                            class: "mb-2 last:mb-0"
                          }, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(vaccine.name), 1),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("span", null, _toDisplayString(vaccine.method), 1),
                              _cache[12] || (_cache[12] = _createElementVNode("span", null, "•", -1)),
                              _createElementVNode("span", null, _toDisplayString(vaccine.dose) + " mL", 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_23, "None"))
                ]),
                _createElementVNode("td", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString((config as any).duration || (config as any).bathDuration || (config as any).vaccinationDuration ? 
                                        formatDuration((config as any).duration || (config as any).bathDuration || (config as any).vaccinationDuration) : 'N/A') + " total ", 1),
                      (getProcessStatus(config).status === 'in_progress' && (config as any).bathProcess?.startedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(getElapsedTime((config as any).bathProcess.startedAt)) + " elapsed ", 1))
                        : _createCommentVNode("", true),
                      (getProcessStatus(config).status === 'completed' && (config as any).bathProcess?.startedAt && (config as any).bathProcess?.completedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(getActualDuration((config as any).bathProcess.startedAt, (config as any).bathProcess.completedAt)) + " actual ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    ((config as any).requiresWeighing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, " Weighing Required "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("td", _hoisted_31, [
                  (isStandardBath(config))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (toggleDropdown(index)),
                          disabled: isUpdating.value[index],
                          class: "flex items-center justify-between w-full min-w-[150px] text-sm border border-gray-300 rounded px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            (selectedTags.value[index])
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "inline-block px-2 py-0.5 text-xs font-medium rounded-full",
                                  style: _normalizeStyle({ 
                                            backgroundColor: selectedTags.value[index]?.backgroundColor || '#e5e7eb', 
                                            color: selectedTags.value[index]?.textColor || '#374151' 
                                        })
                                }, _toDisplayString(selectedTags.value[index]?.title), 5))
                              : (_openBlock(), _createElementBlock("span", _hoisted_35, "Select a tag..."))
                          ]),
                          _cache[13] || (_cache[13] = _createElementVNode("svg", {
                            class: "h-4 w-4 text-gray-500 ml-2 flex-shrink-0",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 9l-7 7-7-7"
                            })
                          ], -1))
                        ], 8, _hoisted_33),
                        (dropdownOpen.value[index])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableTags).filter((tag) => tag.title !== 'Start Tag'), (tag) => {
                                  return (_openBlock(), _createElementBlock("button", {
                                    key: tag.key,
                                    onClick: ($event: any) => (selectTag(index, tag)),
                                    disabled: isUpdating.value[index],
                                    class: "w-full px-3 py-2 text-left hover:bg-gray-50 focus:bg-gray-50 focus:outline-none transition-colors duration-150 flex items-center disabled:opacity-50 disabled:cursor-not-allowed"
                                  }, [
                                    _createElementVNode("span", {
                                      class: "inline-block px-2 py-1 text-xs font-medium rounded-full",
                                      style: _normalizeStyle({ 
                                                backgroundColor: tag.backgroundColor || '#e5e7eb', 
                                                color: tag.textColor || '#374151' 
                                            })
                                    }, _toDisplayString(tag.title), 5)
                                  ], 8, _hoisted_38))
                                }), 128)),
                                (_unref(availableTags).filter((tag) => tag.title !== 'Start Tag').length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, " No tags available "))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_40, "-"))
                ]),
                _createElementVNode("td", _hoisted_41, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium", {
                                'bg-gray-100 text-gray-800': getProcessStatus(config).color === 'gray',
                                'bg-blue-100 text-blue-800': getProcessStatus(config).color === 'blue',
                                'bg-green-100 text-green-800': getProcessStatus(config).color === 'green'
                              }])
                  }, _toDisplayString(getProcessStatus(config).label), 3)
                ]),
                _createElementVNode("td", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    (getProcessStatus(config).status === 'not_started')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: ($event: any) => (handleStartProcess(index)),
                          class: "inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-primary hover:bg-primary/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                        }, " Start Process ", 8, _hoisted_44))
                      : _createCommentVNode("", true),
                    (getProcessStatus(config).status === 'in_progress')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          onClick: ($event: any) => (handleFinishProcess(index)),
                          class: "inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors"
                        }, " Finish Process ", 8, _hoisted_45))
                      : _createCommentVNode("", true),
                    (shouldShowWeightButton(config))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: ($event: any) => (handleRecordWeight(config)),
                          class: "inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors",
                          title: "Record Weight"
                        }, [
                          _createVNode(WeightIcon),
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ml-1" }, "Record Weight", -1))
                        ], 8, _hoisted_46))
                      : _createCommentVNode("", true),
                    (getProcessStatus(config).status === 'completed')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, " ✓ Complete "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (_unref(getVaccinationConfigurationInstructions)(config))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                    _createElementVNode("td", {
                      colspan: _ctx.configurations.some(c => !isSimplifiedBath(c)) ? 8 : 7,
                      class: _normalizeClass(showInstructions.value[index] ? 'px-6 py-4' : 'px-6 py-1.5')
                    }, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (toggleInstructions(index)),
                        class: _normalizeClass(["w-full flex items-center justify-between text-left hover:bg-gray-100 rounded transition-colors duration-200", showInstructions.value[index] ? 'p-3' : 'p-1.5'])
                      }, [
                        _createElementVNode("div", _hoisted_51, [
                          _cache[15] || (_cache[15] = _createElementVNode("svg", {
                            class: "w-4 h-4 text-red-500 flex-shrink-0",
                            fill: "currentColor",
                            viewBox: "0 0 20 20"
                          }, [
                            _createElementVNode("path", {
                              "fill-rule": "evenodd",
                              d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                              "clip-rule": "evenodd"
                            })
                          ], -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(showInstructions.value[index] ? 'text-sm font-semibold text-red-600' : 'text-xs font-semibold text-red-600')
                          }, " Special Instructions ", 2)
                        ]),
                        (_openBlock(), _createElementBlock("svg", {
                          class: _normalizeClass(["w-4 h-4 text-gray-500 transition-transform duration-200", { 'rotate-180': showInstructions.value[index] }]),
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, _cache[16] || (_cache[16] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M19 9l-7 7-7-7"
                          }, null, -1)
                        ]), 2))
                      ], 10, _hoisted_50),
                      _withDirectives(_createElementVNode("div", _hoisted_52, [
                        _createElementVNode("p", _hoisted_53, _toDisplayString(_unref(getVaccinationConfigurationInstructions)(config)), 1)
                      ], 512), [
                        [_vShow, showInstructions.value[index]]
                      ])
                    ], 10, _hoisted_49)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mt-4 p-4 bg-blue-50 rounded-md border border-blue-200" }, [
      _createElementVNode("h4", { class: "text-sm font-medium text-blue-800 mb-2" }, "Bath Process Instructions:"),
      _createElementVNode("ul", { class: "text-sm text-blue-700 space-y-1" }, [
        _createElementVNode("li", null, "• Click \"Start Process\" to begin the bath treatment"),
        _createElementVNode("li", null, "• The process will run for the specified duration"),
        _createElementVNode("li", null, "• Click \"Finish Process\" when ready to complete (justification required if early/late)")
      ])
    ], -1)),
    _createVNode(JustificationModal)
  ]))
}
}

})